import { axios } from "../../lib/axios";

export const ReadNotifications = async (): Promise<void> => {
  await axios.patch(`/notification/mark-as-read-student`);
};
